/* =========================================================
   ART-E-SHOCK UX UPGRADE JS V4
   Safe header search, fast product-card add-to-cart, cart badge, clean filters
   ========================================================= */
(function () {
  'use strict';

  if (window.__AES_UX_UPGRADE_V4__) return;
  window.__AES_UX_UPGRADE_V4__ = true;

  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  var observerTimer = null;
  var observerStarted = false;
  var lastCartCount = 0;
  var lastAnyAddSource = null;

  function qs(selector, context) {
    try { return (context || document).querySelector(selector); } catch (error) { return null; }
  }

  function qsa(selector, context) {
    try { return Array.prototype.slice.call((context || document).querySelectorAll(selector)); } catch (error) { return []; }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function isInsideCartUi(el) {
    return !!(el && el.closest && el.closest('cart-drawer, #CartDrawer, .cart-drawer, cart-notification, .cart-notification'));
  }

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function getVariantIdFromForm(form) {
    if (!form) return '';
    if (form.dataset.aesVariantId) return String(form.dataset.aesVariantId);
    var input = qs('input[name="id"]', form) || qs('select[name="id"]', form) || qs('[name="id"]', form);
    return input && input.value ? String(input.value) : '';
  }

  function getCartElement() {
    return qs('cart-drawer') || qs('#CartDrawer') || qs('cart-notification');
  }

  function getSections(cartElement) {
    var sections = ['cart-drawer', 'cart-icon-bubble', 'cart-notification'];

    if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
      try {
        sections = sections.concat(
          cartElement.getSectionsToRender()
            .map(function (section) { return section && section.id; })
            .filter(Boolean)
        );
      } catch (error) {}
    }

    return sections.filter(function (item, index) {
      return item && sections.indexOf(item) === index;
    });
  }

  function muteCartOpening(cartElement, duration) {
    if (!cartElement) return function () {};

    var methods = ['open', 'show', 'openDrawer', 'showDrawer'];
    var originals = [];

    methods.forEach(function (method) {
      if (typeof cartElement[method] !== 'function') return;

      originals.push({
        method: method,
        value: cartElement[method],
        own: Object.prototype.hasOwnProperty.call(cartElement, method)
      });

      cartElement[method] = function () {};
    });

    return function () {
      setTimeout(function () {
        originals.forEach(function (item) {
          if (item.own) cartElement[item.method] = item.value;
          else delete cartElement[item.method];
        });
      }, duration || 700);
    };
  }

  function renderCartSections(data, silent) {
    var cartElement = getCartElement();
    if (!cartElement || typeof cartElement.renderContents !== 'function') return;

    var restore = silent ? muteCartOpening(cartElement, 900) : function () {};

    try {
      cartElement.renderContents(data);
    } catch (error) {}

    restore();
  }

  function fetchCart() {
    return fetch(root + 'cart.js', {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) { return response.json(); });
  }

  function findCartItem(cart, variantId) {
    if (!cart || !cart.items || !variantId) return null;

    for (var i = 0; i < cart.items.length; i += 1) {
      if (String(cart.items[i].variant_id) === String(variantId)) return cart.items[i];
    }

    return null;
  }

  function getCartIconTarget() {
    var selectors = [
      '.cart-drawer-button',
      'a#cart-icon-bubble',
      '#cart-icon-bubble a[href*="/cart"]',
      'a.header__icon--cart[href*="/cart"]',
      '.header__icon--cart[href*="/cart"]',
      'button.header__icon--cart',
      'button[aria-controls*="CartDrawer"]',
      'button[aria-controls*="cart-drawer"]',
      'cart-icon-bubble',
      '#cart-icon-bubble',
      '.header a[href$="/cart"]',
      '.header a[href*="/cart"]',
      'a[href="/cart"]',
      'a[href$="/cart"]'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var els = qsa(selectors[i]).filter(function (el) {
        return el && !isInsideCartUi(el) && isVisible(el);
      });

      if (els.length) return els[0];
    }

    return null;
  }

  function removeNativeHeaderBadges() {
    qsa('.cart-count-bubble, .cart-counter, .cart-bubble, .count-bubble, .header__cart-count, .header-cart-count, .cart-count').forEach(function (badge) {
      if (!badge || isInsideCartUi(badge)) return;
      if (badge.classList && badge.classList.contains('aes-cart-badge-target')) return;
      badge.style.display = 'none';
    });
  }

  function updateCartBadge(count, bump) {
    var total = Math.max(0, Number(count) || 0);
    lastCartCount = total;

    var target = getCartIconTarget();
    removeNativeHeaderBadges();

    if (!target) return;

    qsa('.aes-cart-badge-target').forEach(function (old) {
      if (old !== target) {
        old.classList.remove('aes-cart-badge-target', 'aes-cart-bump');
        old.removeAttribute('data-aes-cart-count');
      }
    });

    target.classList.add('aes-cart-badge-target');
    target.setAttribute('data-aes-cart-count', String(total));
    target.setAttribute('aria-label', total > 0 ? 'עגלה, ' + total + ' פריטים' : 'עגלה');

    if (window.getComputedStyle(target).position === 'static') {
      target.style.position = 'relative';
    }

    document.documentElement.classList.toggle('cart-has-items', total > 0);

    if (bump) {
      target.classList.remove('aes-cart-bump');
      void target.offsetWidth;
      target.classList.add('aes-cart-bump');
    }
  }

  function refreshBadge() {
    fetchCart()
      .then(function (cart) { updateCartBadge(cart.item_count, false); })
      .catch(function () {});
  }

  function animateFlyToCart(source) {
    try {
      var cartTarget = getCartIconTarget();
      if (!cartTarget || !source) return;

      var card = source.closest ? source.closest('.product-card, .product, product-info') : null;
      var img = card ? qs('.product-card__image-wrapper img, .product__media img, img', card) : null;
      if (!img) return;

      var imgRect = img.getBoundingClientRect();
      var cartRect = cartTarget.getBoundingClientRect();
      if (!imgRect.width || !cartRect.width) return;

      var clone = img.cloneNode(true);
      clone.className = 'aes-fly-to-cart';
      var size = Math.max(44, Math.min(78, imgRect.width * 0.26));
      var startX = imgRect.left + imgRect.width / 2 - size / 2;
      var startY = imgRect.top + imgRect.height / 2 - size / 2;
      var dx = cartRect.left + cartRect.width / 2 - (imgRect.left + imgRect.width / 2);
      var dy = cartRect.top + cartRect.height / 2 - (imgRect.top + imgRect.height / 2);

      clone.style.width = size + 'px';
      clone.style.height = size + 'px';
      clone.style.left = startX + 'px';
      clone.style.top = startY + 'px';
      document.body.appendChild(clone);

      clone.animate([
        { transform: 'translate3d(0,0,0) scale(1)', opacity: 1 },
        { transform: 'translate3d(' + (dx * 0.58) + 'px,' + (dy * 0.35 - 26) + 'px,0) scale(0.72)', opacity: 0.92, offset: 0.56 },
        { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(0.16)', opacity: 0.04 }
      ], {
        duration: 1120,
        easing: 'cubic-bezier(.2,.85,.18,1)'
      });

      setTimeout(function () {
        if (clone && clone.parentNode) clone.parentNode.removeChild(clone);
      }, 1180);
    } catch (error) {}
  }

  function createQtyBlock(form, item) {
    var variantId = item && item.variant_id ? String(item.variant_id) : getVariantIdFromForm(form);
    var qty = item && item.quantity ? item.quantity : 1;
    var lineKey = item && item.key ? item.key : '';

    var wrap = document.createElement('div');
    wrap.className = 'aes-card-qty';
    wrap.setAttribute('data-variant-id', variantId);
    wrap.setAttribute('data-line-key', lineKey);
    wrap.setAttribute('data-qty', String(qty));

    var minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'aes-card-qty__btn aes-card-qty__btn--minus';
    minus.setAttribute('aria-label', 'הורדת כמות');
    minus.setAttribute('data-aes-card-qty-minus', 'true');
    minus.textContent = '−';

    var number = document.createElement('span');
    number.className = 'aes-card-qty__number';
    number.textContent = String(qty);

    var plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'aes-card-qty__btn aes-card-qty__btn--plus';
    plus.setAttribute('aria-label', 'הוספת כמות');
    plus.setAttribute('data-aes-card-qty-plus', 'true');
    plus.textContent = '+';

    wrap.appendChild(minus);
    wrap.appendChild(number);
    wrap.appendChild(plus);

    return wrap;
  }

  function turnFormToQty(form, item) {
    if (!form || !item) return;

    if (!form.dataset.aesOriginalHtml) form.dataset.aesOriginalHtml = form.innerHTML;

    form.dataset.aesVariantId = String(item.variant_id || getVariantIdFromForm(form));
    form.classList.add('aes-card-qty-form');
    form.innerHTML = '';
    form.appendChild(createQtyBlock(form, item));
  }

  function restoreForm(form) {
    if (!form || !form.dataset.aesOriginalHtml) return;

    form.innerHTML = form.dataset.aesOriginalHtml;
    form.classList.remove('aes-card-qty-form');
    fixCardLabels(form);
  }

  function getFormsByVariant(variantId) {
    if (!variantId) return [];

    return qsa('.product-card form[action*="/cart/add"], .product-card form.product-card__actions').filter(function (form) {
      return String(getVariantIdFromForm(form)) === String(variantId);
    });
  }

  function syncVariantCards(variantId, item) {
    if (!variantId) return;

    if (item && item.quantity > 0) {
      getFormsByVariant(variantId).forEach(function (form) {
        turnFormToQty(form, item);
      });

      qsa('.aes-card-qty').forEach(function (block) {
        if (String(block.getAttribute('data-variant-id')) !== String(variantId)) return;

        block.setAttribute('data-line-key', item.key || '');
        block.setAttribute('data-qty', String(item.quantity));

        var number = qs('.aes-card-qty__number', block);
        if (number) number.textContent = String(item.quantity);

        block.classList.remove('is-loading');
      });

      return;
    }

    qsa('.aes-card-qty').forEach(function (block) {
      if (String(block.getAttribute('data-variant-id')) !== String(variantId)) return;
      restoreForm(block.closest('form'));
    });
  }

  function fixCardLabels(context) {
    qsa('.product-card .product-card__atc, .product-card .product-card__action-button', context || document).forEach(function (button) {
      if (!button || button.closest('.aes-card-qty') || button.classList.contains('aes-card-qty__btn')) return;

      var isChoose = button.hasAttribute('aria-controls') && button.getAttribute('aria-haspopup') === 'dialog';
      var label = isChoose ? 'בחרי אפשרויות' : 'הוסיפי לסל';
      var target = qs('.product-card__atc-text, .product-card__action-text', button);

      if (target) target.textContent = label;
      else button.innerHTML = '<span class="aes-atc-label">' + label + '</span>';

      button.setAttribute('aria-label', label);
    });
  }

  function markAllowedFilters() {
    var allowed = ['מחיר', 'זמינות', 'availability', 'price', 'in stock', 'out of stock', 'במלאי', 'לא במלאי'];

    qsa('.facet-accordion-details, .facets__disclosure, .collection__aside details, .facet-drawer-wrapper details').forEach(function (filter) {
      var text = (filter.textContent || '').toLowerCase();
      var isAllowed = allowed.some(function (word) {
        return text.indexOf(word.toLowerCase()) > -1;
      });

      filter.classList.toggle('aes-hidden-filter', !isAllowed);
    });

    var replacements = {
      'In stock': 'במלאי',
      'Out of stock': 'לא במלאי',
      'Availability': 'זמינות',
      'Price': 'מחיר'
    };

    qsa('.facet-accordion-details, .facets__disclosure, .facet-drawer-wrapper, .collection__aside').forEach(function (rootEl) {
      Object.keys(replacements).forEach(function (key) {
        qsa('label, summary, .h4, .filter-item, button, span', rootEl).forEach(function (el) {
          if (el.childElementCount > 1) return;
          if ((el.textContent || '').indexOf(key) > -1) {
            el.textContent = el.textContent.replace(key, replacements[key]);
          }
        });
      });
    });
  }

  function closeNativeSearchDrawer() {
    var drawer = qs('#SearchDrawer, search-drawer');
    if (!drawer) return;

    try {
      drawer.removeAttribute('open');
      drawer.removeAttribute('active');
      drawer.hidden = true;
      document.body.classList.remove('modal-show', 'modal-showing');
    } catch (error) {}
  }

  function formatMoney(value) {
    if (value === null || typeof value === 'undefined' || value === '') return '';

    if (typeof value === 'number') {
      return '₪ ' + (value / 100).toFixed(value % 100 ? 2 : 0);
    }

    if (typeof value === 'string') {
      if (/₪|NIS|ILS|שח|ש״ח|&#8362;/.test(value)) return value;
      if (/^\d+$/.test(value)) return '₪ ' + (Number(value) / 100).toFixed(Number(value) % 100 ? 2 : 0);
      return value;
    }

    return '';
  }

  function getProductImage(product) {
    if (!product) return '';

    if (typeof product.image === 'string') return product.image;
    if (product.image && product.image.url) return product.image.url;
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && product.featured_image.url) return product.featured_image.url;
    if (product.featured_image && product.featured_image.src) return product.featured_image.src;

    return '';
  }


  
function cleanSearchPriceText(value) {
  var text = String(value == null ? '' : value)
    .replace(/\s+/g, ' ')
    .replace(/מחיר רגיל/g, ' ')
    .replace(/מחיר מבצע/g, ' ')
    .replace(/Regular price/gi, ' ')
    .replace(/Sale price/gi, ' ')
    .replace(/Unit price/gi, ' ')
    .replace(/ILS/gi, '₪')
    .replace(/NIS/gi, '₪')
    .replace(/ש"ח|ש״ח|שח/g, '₪')
    .trim();

  // Supports thousands separators and decimal prices.
  var amount = String.raw`(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?`;
  var pricePattern = new RegExp(
    '(?:₪\\s*' + amount + '|' + amount + '\\s*₪)',
    'g'
  );

  var matches = text.match(pricePattern);

  if (matches && matches.length) {
    return matches[0].replace(/\s+/g, ' ').trim();
  }

  return text.length <= 18 ? text : '';
}


  function getProductPrice(product) {
    if (!product) return '';

    var raw = product.price || product.price_min || product.min_price || (product.variants && product.variants[0] && product.variants[0].price);
    var formatted = formatMoney(raw);

    if (formatted) {
      return cleanSearchPriceText(formatted);
    }

    return '';
  }

  function setupSmartSearch() {
    if (window.__AES_SMART_SEARCH_V4_READY__) return;
    window.__AES_SMART_SEARCH_V4_READY__ = true;

    var panel = document.createElement('div');
    panel.className = 'aes-smart-search';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'חיפוש מוצרים');
    panel.innerHTML = '' +
      '<form class="aes-smart-search__bar" action="' + root + 'search" method="get">' +
        '<input type="hidden" name="type" value="product">' +
        '<input type="hidden" name="options[prefix]" value="last">' +
        '<span class="aes-smart-search__icon" aria-hidden="true">⌕</span>' +
        '<input class="aes-smart-search__input" type="search" name="q" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" placeholder="חפשי מוצר..." />' +
      '</form>' +
      '<div class="aes-smart-search__results"><div class="aes-smart-search__hint">הקלידי לפחות 2 אותיות כדי לראות מוצרים</div></div>';

    document.body.appendChild(panel);

    var input = qs('.aes-smart-search__input', panel);
    var results = qs('.aes-smart-search__results', panel);
    var closeBtn = qs('.aes-smart-search__close', panel);
    var activeButton = null;
    var debounceTimer = null;
    var abortController = null;
    var lastQuery = '';

    function close() {
      panel.classList.remove('is-open');
      document.documentElement.classList.remove('aes-search-open');
      activeButton = null;
    }

    function positionPanel(button) {
      var rect = button.getBoundingClientRect();
      var header = button.closest('.header-section, .shopify-section-group-header-group, header') || qs('.header-section');
      var headerRect = header ? header.getBoundingClientRect() : { bottom: 72 };
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      var width = isMobile ? window.innerWidth - 18 : Math.min(440, window.innerWidth - 28);
      var top = isMobile ? Math.max(8, headerRect.bottom + 8) : Math.max(headerRect.bottom + 10, rect.bottom + 10, 72);
      var left = isMobile ? 9 : rect.left + rect.width / 2 - width / 2;

      if (!isMobile) {
        left = Math.max(14, Math.min(left, window.innerWidth - width - 14));
      }

      panel.style.width = width + 'px';
      panel.style.top = top + 'px';
      panel.style.left = left + 'px';
      panel.style.right = 'auto';
    }

    function open(button) {
      activeButton = button;
      closeNativeSearchDrawer();
      positionPanel(button);
      panel.classList.add('is-open');
      document.documentElement.classList.add('aes-search-open');
      setTimeout(function () {
        input.focus();
        input.select();
      }, 40);
      if (!input.value.trim()) {
        results.innerHTML = '<div class="aes-smart-search__hint">הקלידי לפחות 2 אותיות כדי לראות מוצרים</div>';
      }
    }

    function renderProducts(products, query) {
      if (!products || !products.length) {
        results.innerHTML = '<div class="aes-smart-search__empty">לא מצאתי מוצר מתאים כרגע<br><a href="' + root + 'search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query) + '">מעבר לעמוד החיפוש</a></div>';
        return;
      }

      var html = products.slice(0, 8).map(function (product) {
        var url = product.url || (product.handle ? root + 'products/' + product.handle : '#');
        var img = getProductImage(product);
        var title = product.title || product.name || '';
        var price = getProductPrice(product);

        return '<a class="aes-smart-search__item" href="' + escapeHtml(url) + '">' +
          '<span class="aes-smart-search__media">' +
            (img ? '<img class="aes-smart-search__img" src="' + escapeHtml(img) + '" alt="" loading="lazy" />' : '<span class="aes-smart-search__img"></span>') +
          '</span>' +
          '<span class="aes-smart-search__meta">' +
            '<span class="aes-smart-search__title">' + escapeHtml(title) + '</span>' +
            (price ? '<span class="aes-smart-search__price">' + escapeHtml(price) + '</span>' : '') +
          '</span>' +
        '</a>';
      }).join('');

      html += '<a class="aes-smart-search__all" href="' + root + 'search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query) + '">לכל תוצאות החיפוש</a>';
      results.innerHTML = html;
    }

    function parseSuggestProducts(data) {
      if (!data || !data.resources) return [];
      if (data.resources.results && data.resources.results.products) return data.resources.results.products;
      if (data.resources.products) return data.resources.products;
      return [];
    }

    function suggestUrl(query, full) {
      var params = [
        'q=' + encodeURIComponent(query),
        'resources[type]=product',
        'resources[limit]=8',
        'resources[options][unavailable_products]=last'
      ];

      if (full) {
        params.push('resources[options][fields]=title,product_type,variants.title,vendor');
      }

      return root + 'search/suggest.json?' + params.join('&');
    }

    function runSuggest(query, full) {
      if (abortController && full) abortController.abort();
      abortController = window.AbortController ? new AbortController() : null;

      return fetch(suggestUrl(query, full), {
        headers: { Accept: 'application/json' },
        signal: abortController ? abortController.signal : undefined
      }).then(function (response) {
        if (!response.ok) throw new Error('search_failed');
        return response.json();
      }).then(parseSuggestProducts);
    }

    function imageFromSrcset(srcset) {
      if (!srcset) return '';
      var parts = String(srcset).split(',').map(function (part) { return part.trim().split(' ')[0]; }).filter(Boolean);
      return parts.length ? parts[parts.length - 1] : '';
    }

    function cleanText(value) {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }

    function parseProductsFromSearchHtml(html) {
      var doc;
      try {
        doc = new DOMParser().parseFromString(html, 'text/html');
      } catch (error) {
        return [];
      }

      var seen = {};
      var cards = qsa('.product-card, .product-card__wrapper, [class*=\"product-card\"]', doc);
      var products = [];

      cards.forEach(function (card) {
        if (products.length >= 8) return;

        var link = qs('a[href*=\"/products/\"]', card);
        if (!link) return;

        var url = link.getAttribute('href') || '';
        if (!url || seen[url]) return;
        seen[url] = true;

        var titleEl = qs('.product-card__title, .product-card-title, [class*=\"title\"]', card);
        var title = cleanText(titleEl ? titleEl.textContent : link.textContent);
        if (!title) title = cleanText(link.getAttribute('aria-label') || link.getAttribute('title') || '');

        var imgEl = qs('img', card);
        var img = '';
        if (imgEl) {
          img = imgEl.currentSrc || imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || imageFromSrcset(imgEl.getAttribute('srcset')) || imageFromSrcset(imgEl.getAttribute('data-srcset'));
        }

        var priceEl = qs('.f-price, .price, [class*=\"price\"]', card);
        var price = cleanSearchPriceText(priceEl ? priceEl.textContent : '');

        products.push({
          title: title,
          url: url,
          image: img,
          price: price
        });
      });

      return products;
    }

    function runSearchPageFallback(query) {
      var url = root + 'search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);

      return fetch(url, {
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('search_page_failed');
          return response.text();
        })
        .then(parseProductsFromSearchHtml);
    }

    function search(query) {
      if (!query || query.length < 2) return;
      if (query === lastQuery && results.getAttribute('data-query') === query) return;

      lastQuery = query;
      results.setAttribute('data-query', query);
      results.innerHTML = '<div class="aes-smart-search__hint">מחפשת...</div>';

      runSuggest(query, true)
        .then(function (products) {
          if (products && products.length) return products;
          return runSuggest(query, false);
        })
        .then(function (products) {
          if (products && products.length) return products;
          return runSearchPageFallback(query);
        })
        .then(function (products) {
          renderProducts(products, query);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          runSearchPageFallback(query)
            .then(function (products) { renderProducts(products, query); })
            .catch(function () {
              results.innerHTML = '<div class="aes-smart-search__empty">החיפוש לא נטען כרגע<br><a href="' + root + 'search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query) + '">חפשי בעמוד החיפוש</a></div>';
            });
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        lastQuery = '';
        results.removeAttribute('data-query');
        results.innerHTML = '<div class="aes-smart-search__hint">הקלידי לפחות 2 אותיות כדי לראות מוצרים</div>';
        return;
      }

      debounceTimer = setTimeout(function () { search(query); }, 160);
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    panel.addEventListener('submit', function (event) {
      var query = input.value.trim();
      if (!query) {
        event.preventDefault();
        input.focus();
      }
    });

    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('.search-drawer-button');

      if (btn) {
        var header = btn.closest('header');
        var mode = header ? header.getAttribute('data-aes-search-mode') : 'inline';

        if (mode !== 'drawer') {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();

          if (panel.classList.contains('is-open') && activeButton === btn) close();
          else open(btn);

          return;
        }
      }

      if (panel.classList.contains('is-open') && !panel.contains(event.target)) {
        if (!event.target.closest || !event.target.closest('.search-drawer-button')) close();
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    window.addEventListener('resize', function () {
      if (panel.classList.contains('is-open') && activeButton) positionPanel(activeButton);
    }, { passive: true });
  }

  function refreshAll() {
    fixCardLabels(document);
    markAllowedFilters();
    removeNativeHeaderBadges();
  }

  document.addEventListener('submit', function (event) {
    var anyForm = event.target && event.target.closest ? event.target.closest('form[action*="/cart/add"]') : null;
    if (anyForm) lastAnyAddSource = anyForm;

    var form = event.target && event.target.closest ? event.target.closest('.product-card form[action*="/cart/add"]') : null;
    if (!form) return;

    var variantId = getVariantIdFromForm(form);
    if (!variantId) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    if (!form.dataset.aesOriginalHtml) form.dataset.aesOriginalHtml = form.innerHTML;
    form.dataset.aesVariantId = variantId;

    var button = qs('[type="submit"]', form);
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    var cartElement = getCartElement();
    var sections = getSections(cartElement);
    var formData = new FormData(form);
    var quantityInput = qs('[name="quantity"]', form);
    var addQty = quantityInput && Number(quantityInput.value) ? Number(quantityInput.value) : 1;

    formData.set('sections', sections.join(','));
    formData.set('sections_url', window.location.pathname);

    fetch(root + 'cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) throw json;
          return json;
        });
      })
      .then(function (data) {
        var itemLike = {
          variant_id: data.variant_id || variantId,
          quantity: data.quantity || addQty,
          key: data.key || ''
        };

        animateFlyToCart(form);
        updateCartBadge(lastCartCount + addQty, true);
        syncVariantCards(variantId, itemLike);

        setTimeout(function () {
          fetchCart()
            .then(function (cart) {
              updateCartBadge(cart.item_count, true);
              var realItem = findCartItem(cart, variantId);
              syncVariantCards(variantId, realItem);
              renderCartSections(cart, true);
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
            })
            .catch(function () {});
        }, 120);
      })
      .catch(function (error) {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }

        var message = error && (error.description || error.message) ? error.description || error.message : 'לא ניתן להוסיף את המוצר כרגע';
        window.alert(message);
      });
  }, true);

  document.addEventListener('click', function (event) {
    var plus = event.target.closest && event.target.closest('[data-aes-card-qty-plus]');
    var minus = event.target.closest && event.target.closest('[data-aes-card-qty-minus]');
    if (!plus && !minus) return;

    var block = event.target.closest('.aes-card-qty');
    if (!block) return;

    event.preventDefault();
    event.stopPropagation();

    var variantId = block.getAttribute('data-variant-id');
    var lineKey = block.getAttribute('data-line-key') || variantId;
    var currentQty = Number(block.getAttribute('data-qty')) || 1;
    var nextQty = plus ? currentQty + 1 : Math.max(0, currentQty - 1);
    var cartElement = getCartElement();

    block.classList.add('is-loading');
    block.setAttribute('data-qty', String(nextQty));
    var number = qs('.aes-card-qty__number', block);
    if (number) number.textContent = String(nextQty);

    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: nextQty,
        sections: getSections(cartElement),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) throw json;
          return json;
        });
      })
      .then(function (cart) {
        renderCartSections(cart, true);
        updateCartBadge(cart.item_count, true);
        syncVariantCards(variantId, findCartItem(cart, variantId));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      })
      .catch(function () {
        block.classList.remove('is-loading');
        block.setAttribute('data-qty', String(currentQty));
        if (number) number.textContent = String(currentQty);
      });
  });

  document.addEventListener('product-ajax:added', function () {
    if (lastAnyAddSource) animateFlyToCart(lastAnyAddSource);
    setTimeout(refreshBadge, 120);
  });

  document.addEventListener('cart:updated', function (event) {
    if (event && event.detail && typeof event.detail.item_count !== 'undefined') updateCartBadge(event.detail.item_count, false);
    else refreshBadge();
  });

  function initExistingCartQuantities() {
    fetchCart()
      .then(function (cart) {
        updateCartBadge(cart.item_count, false);
        qsa('.product-card form[action*="/cart/add"], .product-card form.product-card__actions').forEach(function (form) {
          var variantId = getVariantIdFromForm(form);
          var item = findCartItem(cart, variantId);
          if (item && item.quantity > 0) turnFormToQty(form, item);
        });
      })
      .catch(function () {});
  }

  function init() {
    setupSmartSearch();
    refreshAll();
    initExistingCartQuantities();

    setTimeout(refreshAll, 350);
    setTimeout(refreshAll, 1200);

    if (!observerStarted && document.body) {
      observerStarted = true;
      new MutationObserver(function () {
        clearTimeout(observerTimer);
        observerTimer = setTimeout(refreshAll, 420);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
